import React, { Component, Fragment } from "reactn";
import { Thumbnail, ThumbnailContainer, ThumbnailGrid } from "./Components/ThumbnailGrid";
import Thumbnails from "js/core/models/thumbnails";
import { ds } from "js/core/models/dataService";
import { app } from "js/namespaces";
import { trackActivity } from "js/core/utilities/utilities";
import {
    LibrarianNoSharedSlidesNotice,
    MemberNoSharedSlidesNotice,
    UpgradeToTeamProNotice
} from "js/react/views/UserOptions/dialogs/NoResourcesNotices";
import { FeatureType } from "common/features";
import {
    ShowConfirmationDialog,
    ShowDialog,
    ShowErrorDialog,
    ShowMessageDialog
} from "js/react/components/Dialogs/BaseDialog";
import { TeamSlideDataService } from "js/react/views/AddSlide/SlideLibraryDataService";
import { UIPane, RoundIconButton, IconMenu } from "js/react/components/UiComponents";
import Spinner from "js/react/components/Spinner";
import { Gap, Gap10, Gap20, Gap30 } from "js/react/components/Gap";
import { Icon, MenuItem, Tooltip } from "@material-ui/core";
import styled from "styled-components";
import { themeColors } from "js/react/sharedStyles";
import SortAlphabeticalVariant from "mdi-material-ui/SortAlphabeticalVariant";
import Update from "mdi-material-ui/Update";
import CalendarRange from "mdi-material-ui/CalendarRange";
import Numeric from "mdi-material-ui/Numeric";
import Star from "mdi-material-ui/Star";
import { SUGGEST_TEMPLATE_FORM, THUMBNAIL_SIZES } from "common/constants";
import { EditSharedSlideDialog, TeamSlideDialog } from "js/editor/TeamResources/TeamSlideDialog";
import {
    SearchBarContainer,
    SearchBarInnerContainer,
    UIPaneResultsContainer, InnerWhiteFrameContainer,
    SlideSearchInput
} from "./Components/SearchBox";
import { SortMenu } from "./Components/SortMenu";
import { fullTextSearchApi } from "js/core/fullTextSearchApi";
import { NoMatchesFoundContainer } from "./Components/NoMatchesFoundContainer";
import { _ } from "../../../../vendor";
import { SearchThrottleWait } from "common/constants";
import { UIController } from "../../../../editor/dialogs/UIController";
import { FilterDropDown } from "js/react/views/AddSlide/Panes/Components/FilterDropDown";
import { appSearchNames } from "../../../../config";
import { Breadcrumb } from "js/editor/PresentationLibrary/PresentationLibrary";
import log from "js/core/logger";

const filterOptions = [
    {
        id: "all_content",
        name: "All Content"
    },
    {
        id: "name",
        name: "Title"
    },
    {
        id: "description",
        name: "Description"
    },
    {
        id: "text",
        name: "Slide Content"
    },
    {
        id: "tags",
        name: "Tags"
    },
    {
        id: "template",
        name: "Template"
    },
];

const TeamPanel = styled.div`
  position: relative;
  display: flex;
  background: ${themeColors.lightGray};
  width: 100%;
  height: 100%;
  align-items: flex-start;
  justify-content: flex-start;
  pointer-events: auto;
  
  .search-frame{
    padding-left: 0px;
    padding-right: 0px;
    top: -4px;
  }
`;

const TeamSidebar = styled.div`
  width: 200px;
  margin-top: 10px;
  overflow: hidden;
`;

const Frame = styled.div`
   background: white;
   padding: 20px;
`;

export const TeamSlideLibraryContainer = styled(UIPaneResultsContainer)`
  padding: 0px 0px 60px 20px;
`;

export class TeamSlideLibraryPane extends Component {
    constructor(props) {
        super(props);

        this.scrollRef = React.createRef();
        this.state = {
            isLoaded: false,
            query: "",
            sort: null,
            thumbnailSize: 250,
            items: [],
            tags: [{ id: "all_tags", name: "All Tags" }],
            selectedContent: "all_content",
            selectedTag: "all_tags",
            searchResults: []
        };

        this.fetchSearchResultsThrottled = _.throttle(this.fetchSearchResults, SearchThrottleWait, { leading: false });
    }

    componentDidMount() {
        if (!this.props.organizationId) {
            this.setState({ showNoItemsWarning: true });
        } else {
            ds.teamSlideDataService = new TeamSlideDataService({
                onChanged: () => {
                    this.loadData();
                }
            });
            this.loadData();
        }
    }

    loadData() {
        const { query, searchResults, sort } = this.state;

        ds.teamSlideDataService.loadData(this.props.organizationId, this.props.isManageLibrary).then(() => {
            this.setState({
                ds: ds.teamSlideDataService,
                items: ds.teamSlideDataService.getItems(query, searchResults, sort),
                tags: [{ id: "all_tags", name: "All Tags" }, ...ds.teamSlideDataService.tags],
                isLoaded: true,
                showNoItemsWarning: !Object.keys(ds.teamSlideDataService.data).length
            });

            if (this.global.searchSlidesQuery) {
                this.handleSearch(this.global.searchSlidesQuery);
                this.setGlobal({
                    searchSlidesQuery: null
                });
            }
        });
    }

    get sortOptions() {
        return [{
            value: "name", label: "Name", icon: <SortAlphabeticalVariant />
        }, {
            value: "ratedByCount", label: "Rating", reverse: true, icon: <Star />
        }, {
            value: "presentationCount", label: "Popularity", reverse: true, icon: <Numeric />
        }, {
            value: "createdAt", label: "Created At", reverse: true, icon: <CalendarRange />
        }, {
            value: "modifiedAt", label: "Modified At", reverse: true, icon: <Update />
        }];
    }

    handleItemSelected = async slide => {
        if (this.props.isManageLibrary) {
            return ShowDialog(TeamSlideDialog, {
                organizationId: this.props.organizationId,
                libraryItemId: slide.libraryId,
                openFromLibrary: true,
                closePane: this.props.closePane,
                callback: () => {
                    this.loadData();
                }
            });
        } else {
            const props = {
                ...ds.selection.presentation.getAnalytics(),
                slide_id: slide.id,
            };
            trackActivity("Presentation", "LibrarySlideAdded", null, null, props);
            this.props.onSelected(slide);
        }
    }

    handleSelectTag = event => {
        this.setState({
            selectedTag: event.target.value,
        });
    }

    fetchSearchResults = async query => {
        const { selectedContent } = this.state;
        let fields = [];
        if (selectedContent && selectedContent !== "all_content") {
            fields.push(selectedContent);
        }
        const searchResults = await fullTextSearchApi(query, appSearchNames.sharedSlidesSearchEngine, fields);

        this.setState({
            searchResults,
            isLoaded: true
        });
    }

    handleSearch = query => {
        this.setState({
            query,
            isLoaded: true,
        });

        this.fetchSearchResultsThrottled(query);
    }

    handleSort = sort => {
        this.setState({ sort });
    }

    handleFilterChange = event => {
        const { query } = this.state;
        this.setState(
            { selectedContent: event.target.value, isLoaded: false },
            () => {
                this.fetchSearchResults(query);
            });
    }

    handleAddItem = async () => {
        ShowDialog(EditSharedSlideDialog, {
            slideId: null,
            openFromLibrary: true,
        });
    }

    handleEditSlide = async item => {
        ShowDialog(EditSharedSlideDialog, {
            slideId: item.contentId,
            openFromLibrary: true
        });
    }

    handleDeleteSlide = async item => {
        let backboneLibraryItem = item.libraryItem;

        if (item.usedInPresentations) {
            if (await ShowConfirmationDialog({
                title: "Sorry, you can't delete a Team Slide that is currently used in presentations.",
                message: "If you want to prevent this Team Slide from being used in any additional presentations, you can hide the slide.",
                okButtonLabel: "Hide Slide"
            })) {
                backboneLibraryItem.update({ isDisabled: true });
                const props = {
                    slide_id: backboneLibraryItem.get("contentId"),
                };
                trackActivity("SharedSlideLibrary", "SlideDisabled", null, null, props);
                this.loadData();
            }
            return;
        }

        ShowConfirmationDialog({
            title: "Are you sure you want to delete this Team Slide?",
            message: "Deleting a Team Slide permanently removes it from your Team Slides library and prevents it from being used in any future presentations.",
            buttonOptions: { cancelButtonVariant: "outlined", acceptButtonColor: "red" },
            okButtonLabel: "PERMANENTLY DELETE TEAM SLIDE",
            acceptCallback: async () => {
                this.setState(prevState => {
                    return {
                        ...prevState,
                        isLoading: true
                    };
                });
                try {
                    await backboneLibraryItem.destroy();
                    const props = {
                        slide_id: backboneLibraryItem.get("contentId"),
                    };
                    trackActivity("SharedSlideLibrary", "SlideDeleted", null, null, props);
                    this.loadData();
                } catch (err) {
                    log.error(err);
                    ShowErrorDialog({
                        error: "An error occurred while deleting the Team Slide.",
                        message: (
                            <Fragment>
                                <p>
                                    <strong>Error:</strong> {err.message}
                                </p>
                                <p>We apologize for the inconvenience. Please contact us at support@beautiful.ai.</p>
                            </Fragment>
                        )
                    });
                }
            }
        });
    }

    render() {
        const { isManageLibrary } = this.props;
        const { query, selectedTag, showNoItemsWarning, selectedContent, tags } = this.state;

        if (showNoItemsWarning) {
            return (
                <UIPane>{this.renderNoItems()}</UIPane>
            );
        }

        let panelStyles, searchStyles, scrollStyles;
        if (!isManageLibrary) {
            panelStyles = {
                paddingTop: 4,
                paddingRight: 20,
                paddingBottom: 0,
                paddingLeft: 20
            };
            searchStyles = {
                position: "initial"
            };
        } else {
            scrollStyles = {
                height: "calc(100% - 49px)"
            };
        }

        return (
            <UIPane>
                <SearchBarContainer className="search-container">
                    {isManageLibrary &&
                        <Fragment>
                            <Breadcrumb>Team Slides</Breadcrumb>
                            <RoundIconButton onClick={this.handleAddItem}><Icon>add</Icon></RoundIconButton>
                            <Gap size={60}/>
                        </Fragment>
                    }
                    <SearchBarInnerContainer>
                        <SlideSearchInput
                            query={this.global.searchSlidesQuery || query}
                            onSearch={this.handleSearch}
                            placeholder="Search team slides..."
                        />
                        <FilterDropDown
                            onChange={this.handleFilterChange}
                            selectedFilter={selectedContent}
                            filterOptions={filterOptions}
                        />
                        <FilterDropDown
                            onChange={this.handleSelectTag}
                            selectedFilter={selectedTag}
                            filterOptions={tags}
                        />
                        <SortMenu
                            disabled={query.length > 0}
                            sortOptions={this.sortOptions}
                            onSetSort={this.handleSort}
                        />
                    </SearchBarInnerContainer>
                </SearchBarContainer>
                <TeamSlideLibraryContainer>
                    <InnerWhiteFrameContainer>
                        {this.renderSlides()}
                    </InnerWhiteFrameContainer>
                </TeamSlideLibraryContainer>
            </UIPane>
        );
    }

    renderSlides() {
        const { isManageLibrary } = this.props;
        const { ds, sort, query, selectedTag, isLoaded, searchResults, selectedContent } = this.state;
        const items = ds && ds.getItems(query, searchResults, sort, selectedTag);

        if (!isLoaded) {
            return <Spinner />;
        } else if (query.length && !items.length) {
            return <NoMatchesFoundContainer context="templates" onAddClassicSlide={this.props.onAddBlankClassicSlide} urlSuggestionForm={SUGGEST_TEMPLATE_FORM} />;
        } else {
            return (
                <ThumbnailGrid
                    items={items}
                    columns={3}
                    thumbnailClass={TeamSlideThumbnail}
                    thumbnailProps={{
                        isManageLibrary,
                        onEditSlide: this.handleEditSlide,
                        onDeleteSlide: this.handleDeleteSlide
                    }}
                    onItemDoubleClick={this.handleItemSelected}
                />
            );
        }
    }

    renderNoItems() {
        const workspaceId = UIController.getWorkspaceId();
        if (app.user.features.isFeatureEnabled(FeatureType.TEAMS, workspaceId)) {
            if (app.user.features.isFeatureEnabled(FeatureType.EDIT_LIBRARY_ITEMS, workspaceId)) {
                return <LibrarianNoSharedSlidesNotice />;
            } else {
                return <MemberNoSharedSlidesNotice />;
            }
        } else {
            return <UpgradeToTeamProNotice workspaceId={workspaceId} />;
        }
    }
}

const TeamSlideThumbnailBar = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 10px;
  label {
    flex-grow: 2;
    text-align: left;
    margin: 0px 10px 0px 0px;
  }
  .MuiIcon-root {
    margin-right: 3px;
    font-size: 18px;
  }
  & > div {
    font-size: 12px;
  }
  .star-button{
    color: ${props => props.liked ? themeColors.yellow : "inherit"};
    
    &:hover {
      color: ${themeColors.yellow}
    }
  }
  button {
      padding: 2px;
  }
`;

const IconBlueOnHover = styled(Icon)`
&:hover {
    color: ${themeColors.ui_blue};
}
`;

export class TeamSlideThumbnail extends Component {
    constructor() {
        super();

        this.state = {
            url: "",
            isVisible: false
        };

        this.ref = React.createRef();
    }

    componentDidMount() {
        const observer = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting === true) {
                observer.disconnect();
                this.setState({ isVisible: true });
            }
        });

        observer.observe(this.ref.current);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { isVisible } = this.state;

        if (prevState.isVisible !== isVisible && isVisible) {
            this.loadThumbnail()
                .catch(err => log.error(err));
        }
    }

    componentWillUnmount() {
        this.isUnmounted = true;
    }

    async loadThumbnail() {
        const { item, highQuality, showThemeThumbnails = true } = this.props;

        // let slideId = item.libraryItem.get("contentId");
        let slideId = item.id;

        let url;

        if (showThemeThumbnails && ds.selection.presentation && !ds.selection.presentation.get("isDummy")) {
            const presentationId = ds.selection.presentation.id;
            const firstSlideModifiedAt = ds.selection.presentation.get("firstSlideModifiedAt");
            url = await Thumbnails.getSignedUrlAndLoad(slideId, firstSlideModifiedAt, presentationId, THUMBNAIL_SIZES[highQuality ? "large" : "small"].suffix);
        } else {
            url = await Thumbnails.getSignedUrlAndLoad(slideId, item.modifiedAt);
        }

        if (!this.isUnmounted) {
            this.setState({ url });
        }
    }

    handleLikeItem = () => {
        let { item } = this.props;

        if (item.ratedByUsers && item.ratedByUsers[app.user.id]) {
            item.libraryItem.update({
                ratedByUsers: { [app.user.id]: null }
            });
        } else {
            item.libraryItem.update({
                ratedByUsers: { [app.user.id]: true }
            });
        }

        // this is ugly but we need to update the item props and re-render
        item.ratedByCount = Object.keys(item.libraryItem.attributes.ratedByUsers || {}).length;
        item.ratedByUsers = item.libraryItem.attributes.ratedByUsers;

        this.forceUpdate();
    }

    render() {
        let { item, onDoubleClick, selected, ignoreMetadata, isManageLibrary, onEditSlide, onDeleteSlide } = this.props;
        let { url } = this.state;

        let clickProps;
        if (isManageLibrary) {
            clickProps = {
                onDoubleClick: onDoubleClick
            };
        } else {
            clickProps = {
                onClick: onDoubleClick
            };
        }

        return (
            <ThumbnailContainer ref={this.ref}>
                <Thumbnail
                    {...clickProps}
                    url={url} selected={selected} showSpinner={true}
                    style={{ border: "solid 1px #ccc", boxShadow: "0px 0px 20px rgba(0,0,0,0.05)" }}>
                    {item.isDisabled && <DisabledSlideIcon><Icon>visibility_off</Icon></DisabledSlideIcon>}
                </Thumbnail>
                <TeamSlideThumbnailBar liked={item.ratedByUsers && item.ratedByUsers[app.user.id]}>
                    <label>{item.name}</label>
                    <Icon onClick={this.handleLikeItem} className="star-button">star</Icon>
                    <div>{item.ratedByCount}</div>
                    <Gap10 />
                    <Icon>cloud_download</Icon>
                    <div>{item.presentationCount}</div>
                    <Gap10 />
                    <Tooltip
                        title={(
                            <div style={{ padding: 10 }}>
                                {item.description || "No description available"}
                            </div>
                        )}
                        classes={{ popper: "popper-white rounded-5" }}
                        placement="top"
                        arrow
                        interactive
                    >
                        <IconBlueOnHover>info</IconBlueOnHover>
                    </Tooltip>
                    {isManageLibrary &&
                        <Fragment>
                            <Gap20/>
                            <IconMenu>
                                <MenuItem divider onClick={() => onEditSlide(item)}><Icon>edit</Icon>Edit Slide..</MenuItem>
                                <MenuItem divider onClick={onDoubleClick}><Icon>label</Icon>View Properties...</MenuItem>
                                <MenuItem onClick={() => onDeleteSlide(item)}><Icon>delete</Icon>Delete Slide</MenuItem>
                            </IconMenu>
                        </Fragment>
                    }
                </TeamSlideThumbnailBar>
            </ThumbnailContainer>
        );
    }
}

const DisabledSlideIcon = styled.div`
  position:absolute;
  top: 8px;
  right: 8px;
  width: 30px;
  height: 30px;
  z-index: 100;
  border-radius: 50%;
  background: orangered;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    color: white;
    font-size: 20px;
  }
`;
